import React, { Component } from "react";
import { formatCurrency } from "../../../utils/constants";
import { AppContext } from "../../../utils/context";
import classnames from 'classnames';

const WinningTicket = (draw, title, showCard = true) => {
  if (draw.number !== null && draw.draw_at !== null) {
    return (
      <div className="block px-6">
        <div className={draw.winning_card ? "" : ""}>
          {title.split('\n').map((item, key) => {
            return <span key={key} className="text-base">{item.replace(/ /g, "\u00a0").toUpperCase()}<br /></span>
          })}
          <div className="text-base mb-2">WINNING TICKET:</div>
          <div className="font-bold text-2xl mb-2">#{draw.number}</div>
          {showCard && draw.card ? (
            <div>
              <span className="inline md:hidden font-bold">Card: </span>
              {draw.card.suit === "D" ? (<span style={{ "color": "red" }}>&diams;</span>) : ""}
              {draw.card.suit === "H" ? (<span style={{ "color": "red" }}>&hearts;</span>) : ""}
              {draw.card.suit === "S" ? (<span style={{ "color": "black" }}>&spades;</span>) : ""}
              {draw.card.suit === "C" ? (<span style={{ "color": "black" }}>&clubs;</span>) : ""}
              {" " + draw.card.rank}

              {" "} in Envelope: #{draw.card.envelope}
            </div>
          ) : (
              <div className="text-xs italic mt-1">See Rules for {title}</div>
            )}
        </div>
      </div>
    )
  }
  return '';
}

class ChaseTheAce extends Component {
  render() {
    const { title, date, jackpot, prize, draws } = this.props.event;
    const { language, settings } = this.props;
    const { config } = this.context;

    const heroDrawTitleClasses = classnames('font-semibold', 'mb-2',  settings.font_size_raffle_title ); //text-3xl
    const heroProgressiveJackpotClasses = classnames('font-bold', settings.font_size_progressive_jackpot_title ); //text-5xl
    const heroWeeklyPrizeClasses = classnames('font-bold ', settings.font_size_weekly_prize_title ); //text-5xl
    const heroDrawDateLabelClasses = classnames('font-light', settings.font_size_draw_date_label ); //text-xs
    const heroDrawDateClasses = classnames('font-light', settings.font_size_draw_date_value ); //text-base

    return (
      <div >
        <div className={heroDrawTitleClasses} style={{ color: settings.hero_draw_title_color }}>{title}</div>
        <div className={heroDrawDateLabelClasses} style={{ color: settings.hero_draw_title_color }}>DRAW DATE:</div>
        <div className={heroDrawDateClasses} style={{ color: settings.hero_draw_title_color }}>{date}</div>
        <div className="jackpot" >
          <div style={{ color: settings.hero_progressive_title_color }}>
            <div className="text-2xl my-3 pb-4">
              {language.game_3_jackpot_title.toUpperCase()}
            </div>
            <div className={heroProgressiveJackpotClasses}>
              {formatCurrency(jackpot, config.language)}
            </div>
            {draws[0].winning_card && draws[1] && (
              <div className="mb-8">{WinningTicket(draws[0], language.game_3_final_draw, false)}</div>
            )}
          </div>
          <div style={{ color: settings.hero_weekly_title_color }} >
            <div className="text-2xl my-3 pb-4">
              {language.game_3_prize_title.toUpperCase()}
            </div>
            <div className={heroWeeklyPrizeClasses}>
              {formatCurrency(prize, config.language)}
            </div>
            {draws.length > 1 && draws[1].number !== null && (<div className="mb-8">{WinningTicket(draws[1], language.game_3_prize_title)}</div>)}
            {!draws[0].winning_card && draws[0].number !== null && (<div className="mb-8">{WinningTicket(draws[0], language.game_3_prize_title)}</div>)}
            {draws[0].winning_card && !draws[1] && (
              <div className="mb-8">{WinningTicket(draws[0], language.game_3_jackpot_title + '\n& ' + language.game_3_prize_title)}</div>
            )}
          </div>
        </div>

        {draws[0].number !== null && (<span> See all winners</span>)}

      </div>
    );
  }
}

ChaseTheAce.contextType = AppContext;
export default ChaseTheAce;
